'use client'

import _ from 'lodash'
import { forwardRef, useState } from 'react'
import { twMerge } from 'tailwind-merge'

type InputProps = {
  className?: string
  label?: string
  name: string
  value?: string
  placeholder?: string
} & React.ComponentPropsWithoutRef<'input'>

const Password = forwardRef<HTMLInputElement, InputProps>((props: InputProps, ref) => {
  const { className, label, name, placeholder, onChange, onBlur } = props
  const [showPassword, setShowPassword] = useState(false)
  const errMsg = _.get(props, 'data-error')
  return (
    <div>
      {label && (
        <label htmlFor={name} className='block font-medium dark:text-zinc-200 text-sm/6'>
          {label}
        </label>
      )}
      <div className='mt-1.5 flex rounded '>
        <div className='relative flex grow items-stretch focus-within:z-10'>
          <div className='relative flex grow items-stretch focus-within:z-10 text-sm/6'>
            <input
              ref={ref}
              onChange={onChange}
              onBlur={onBlur}
              id={name}
              name={name}
              type={showPassword ? 'text' : 'password'}
              placeholder={placeholder || 'password'}
              className={twMerge(
                'block w-full rounded-none rounded-l-md border-0 px-3 py-1.5 h-10',
                'ring-1 ring-inset ring-zinc-300 placeholder:text-zinc-400 focus:ring-zinc-600',
                'dark:bg-transparent dark:ring-zinc-500',
                className,
                errMsg && 'ring-red-800',
              )}
            />
          </div>
          <button
            type='button'
            className={twMerge(
              'relative -ml-px inline-flex items-center justify-center gap-x-1.5 rounded-r-md px-3 py-2',
              'w-16 text-sm font-medium text-zinc-900 dark:text-zinc-300 ring-1 ring-inset ring-zinc-300 dark:ring-zinc-500',
              'hover:bg-zinc-100 dark:hover:bg-zinc-700',
            )}
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? 'Hide' : 'Show'}
          </button>
        </div>
      </div>
      <div className='h-3 py-1 pl-3 text-xs text-red-800 dark:text-orange-500'>{errMsg}</div>
    </div>
  )
})

export default Password
